import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import axios from 'axios';
import { Button, FormField, Input, PasswordInput } from '@/components';
import { AuthLayout } from '@/components/layout/AuthLayout';
import { useLogin } from '@/hooks/useAuth';

type FormValues = {
  email: string;
  password: string;
};

export function Login() {
  const navigate = useNavigate();
  const location = useLocation() as any;
  const from = location?.state?.from?.pathname || '/';

  const { register, handleSubmit, formState } = useForm<FormValues>({
    defaultValues: { email: '', password: '' },
  });

  const login = useLogin();

  const onSubmit = handleSubmit(async (values) => {
    try {
      await login.mutateAsync(values);
      toast.success('Bem-vindo!');
      navigate(from, { replace: true });
    } catch (e) {
      if (axios.isAxiosError(e)) {
        const status = e.response?.status;
        if (status === 401) {
          toast.error('Credenciais inválidas');
          return;
        }

        toast.error('Login indisponível. Verifique se os mocks estão ativos (VITE_USE_MOCKS=true) ou se o backend está rodando.');
        return;
      }

      toast.error('Não foi possível autenticar.');
    }
  });

  return (
    <AuthLayout>
      <div className="auth-header">
        <h1>Entrar</h1>
        <p>Acesse o painel administrativo.</p>
      </div>

      <form onSubmit={onSubmit} className="auth-form">
        <FormField label="Email" error={formState.errors.email?.message}>
          <Input type="email" autoComplete="email" {...register('email', { required: 'Informe seu email' })} />
        </FormField>

        <FormField label="Senha" error={formState.errors.password?.message}>
          <PasswordInput autoComplete="current-password" {...register('password', { required: 'Informe sua senha' })} />
        </FormField>

        <div className="auth-actions">
          <Button type="submit" variant="primary" disabled={login.isLoading}>
            Entrar
          </Button>
          <button type="button" className="link" onClick={() => navigate('/forgot-password')}>
            Esqueci minha senha
          </button>
        </div>
      </form>
    </AuthLayout>
  );
}
